import { Schema as S } from "effect";
export const Schema = S.Number.pipe(S.brand("@open-revenue/schema/ProjectId"), S.annotations({
    description: "A unique identifier for a project."
}));
export const FromString = S.compose(S.NumberFromString, Schema);
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
